import React, { useCallback } from 'react';
import cx from 'classnames';

import { Button, Icon } from '@atlas/ui';

import useTranslate from 'common/I18n/Interpreter';
import { useSearch } from 'hooks/useSearch';

import { useSearchInputState } from './context/InputProvider';

const SearchInput = ({ className, onCancel, onClean, onSearch }) => {
  const t = useTranslate();

  const { searchString } = useSearch();
  const { focused, setFocused } = useSearchInputState();

  const isCancelButtonVisible = focused || searchString;

  const inputClassName = cx('search-input-container', className, {
    'search-active': isCancelButtonVisible,
  });

  const onFocusInputHandler = useCallback(() => {
    if (focused) return;
    setFocused(focusInput => !focusInput);
  }, [focused, setFocused]);

  const onKeyUpHandler = useCallback(({ currentTarget, key }) => {
    if (key === 'Enter') {
      currentTarget.blur();
    }
  }, []);

  return (
    <div className={inputClassName}>
      <div className="search-input">
        <div className="search-icon-container">
          <Icon name="search" />
        </div>
        <input
          enterKeyHint="done"
          inputMode="search"
          onChange={onSearch}
          onFocus={onFocusInputHandler}
          onKeyUp={onKeyUpHandler}
          placeholder={t('search_events')}
          value={searchString}
        />
        {searchString && (
          <button className="clean-search-button" onClick={onClean} type="button">
            <Icon className="icon-close" name="close" />
          </button>
        )}
      </div>
      {isCancelButtonVisible && (
        <Button label="Cancel" onClick={onCancel} size="small" type="text" />
      )}
    </div>
  );
};

export default SearchInput;
